interface stateZip {
  state?: string;
  zipcode?: string;
}

interface policyNumber {
  policyCode?: string;
  policyNumber?: string;
  zipCode?: string;
}

export const carrierTestDefaultFormValues: Record<
  string,
  stateZip | policyNumber
> = {
  aaa_alabama: {},
  'aaa_auto-club-group': {
    state: 'TN',
    zipcode: '37013',
  },
  aaa_michigan: {
    state: 'MI',
    zipcode: '48003',
  },
  aaa_missouri: { zipcode: '63158' },
  'aaa_new-mexico': { zipcode: '87121' },
  mapfre_all: { state: 'OH' },
  'traders-insurance': {
    policyCode: 'TM',
    policyNumber: '24624812',
    zipCode: '64086',
  },
};
